import { render } from "./BasicBarAreaChart.vue?vue&type=template&id=91efbc06&ts=true"
import script from "./BasicBarAreaChart.vue?vue&type=script&lang=ts"
export * from "./BasicBarAreaChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__